import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { loadPublicResourcesForHub } from "@/lib/query-registry";
import { ResourceHub, collectionPageJsonLd } from "@/components/site/ResourceHub";
import { SITE_URL } from "@/lib/i18n";
import coverMigEs from "@/assets/cover-pillar-migration-es.jpg";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/es/recursos/migracion";
const ALT = "/resources/migration";
const TITLE = "Recursos de migración a Shopify: por plataforma origen · Shugert";
const DESC =
  "Guías de migración a Shopify desde WooCommerce, Magento, BigCommerce, plataformas custom y tiendas Shopify legacy, con datos, SEO, integraciones y decisión entre Shopify y Shopify Plus.";

export const Route = createFileRoute("/es/recursos/migracion")({
  loader: async ({ context }) => {
    await setEdgeHtmlCache();
    return loadPublicResourcesForHub(context.queryClient);
  },
  head: ({ loaderData }) => {
    const resources = (loaderData as any)?.resources ?? [];
    const urls = resources
      .filter((r: any) =>
        ((r.tags_es?.length ? r.tags_es : r.tags_en) ?? []).join(" ").toLowerCase()
          .match(/migration|migración|migracion|replatform|bigcommerce|magento|woocommerce/),
      )
      .map((r: any) => `${SITE_URL}/es/recursos/${r.slug_es ?? r.slug}`);
    return buildHead({
      locale: "es",
      title: TITLE,
      description: DESC,
      path: PATH,
      altPath: ALT,
      ogImage: coverMigEs,
      jsonLd: [
        breadcrumbJsonLd([
          { name: "Inicio", path: "/es" },
          { name: "Recursos", path: "/es/recursos" },
          { name: "Migración", path: PATH },
        ]),
        collectionPageJsonLd("Recursos de Migración a Shopify", `${SITE_URL}${PATH}`, DESC, urls),
      ],
    });
  },
  component: () => (
    <SiteShell>
      <ResourceHub
        locale="es"
        cluster="migration"
        copy={{
          eyebrow: "Recursos de migración",
          title: "Recursos de migración a Shopify: por plataforma origen y requisito operativo.",
          intro:
            "Usa este hub para migraciones desde WooCommerce, Magento, BigCommerce, plataformas custom y tiendas Shopify legacy. La mayoría de los proyectos puede terminar en Shopify estándar; las guías de Shopify Plus cubren la ruta premium sólo cuando B2B, checkout extensibility, Functions, Markets complejos, múltiples tiendas o integraciones enterprise lo justifican.",
          serviceLabel: "Ver servicios de migración a Shopify",
          serviceHref: "/es/migracion-shopify",
          articlesTitle: "Guías de migración",
          articlesEmpty: "Más guías de migración pronto. ¿Necesitas ayuda ahora? Solicita un scope.",
          read: "Leer",
          min: "min",
          by: "Por",
          updated: "Actualizado",
          backLabel: "Recursos",
          backHref: "/es/recursos",
        }}
      />
    </SiteShell>
  ),
});
